import { useTranslate } from 'core/hooks/useTranslate';
import { getDateWithoutTimeZone } from 'core/utils/date';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';

function useModuleItem({ modules, parent_guid, visibility, guid, onChangeModuleVisibility, sessionInfo, studentGradebook, isEdelvives, isEditorial, twoLevelProgram }) {
  const { t } = useTranslate();

  const [anchorLessons] = useState({});
  const [openDropDownLessons, setOpenDropDownLessons] = useState(false);
  const [progress, setProgress] = useState({ total: 0, completed: 0 });
  const [sessionProgress, setSessionProgress] = useState(0);
  const [hasCurrentSession, setHasCurrentSession] = useState(false);
  const [allSessionsCompleted, setAllSessionsCompleted] = useState(false);
  const [sessionDateDatesInfo, setsessionDateDatesInfo] = useState(
    t('course:Start date') + ': ' + moment(new Date(sessionInfo[0]?.session_date)).format('DD MMMM YYYY')
  );

  useEffect(() => {
    setProgress(calculateProgress());
    setSessionProgress(calculateSessionProgress());
    setHasCurrentSession(sessionInfo?.some((session) => session.currentSession));
    setAllSessionsCompleted(sessionInfo?.length > 0 && sessionInfo?.every((session) => session.completed));
    let date = sessionInfo[0] && sessionInfo[0]?.session_date ? getDateWithoutTimeZone(new Date(sessionInfo[0]?.session_date)) : null;
    setsessionDateDatesInfo(t('course:Start date') + ': ' + moment(date).format('DD MMMM YYYY'));
  }, [sessionInfo]);

  const optionsModules = useMemo(() => {
    return modules.filter((module) => module.guid !== parent_guid && (!isEdelvives || isEditorial || twoLevelProgram || module.is_accessible === 1));
  }, [modules, isEdelvives, isEditorial, twoLevelProgram]);

  const options = useMemo(() => {
    return getOptions();
  }, [visibility, optionsModules]);

  function handleCloseDropdown() {
    setOpenDropDownLessons(false);
  }

  function onClickInOption(item, e) {
    handleCloseDropdown();
    if (item.onClick) {
      item.onClick(item, e);
    }
  }

  function onClickChangeVisibleLesson(e, visibility) {
    e.preventDefault();
    e.stopPropagation();
    onChangeModuleVisibility(guid, visibility);
  }

  function getOptions() {
    return [
      {
        name: visibility === 1 ? t('course:Hide module') : t('course:Show module'),
        icon: visibility === 1 ? 'visible-off' : 'visible',
        onClick: visibility === 1 ? (item, e) => onClickChangeVisibleLesson(e, false) : (item, e) => onClickChangeVisibleLesson(e, true),
      },
    ];
  }

  const calculateSessionProgress = () => {
    if (!sessionInfo?.length) return 0;

    const completedSessions = sessionInfo.filter((session) => session?.completed === true).length;
    return Math.round((completedSessions / sessionInfo.length) * 100);
  };

  // Calculamos el progreso del alumno basado en las actividades completadas
  const calculateProgress = () => {
    const module = studentGradebook?.periods?.flatMap((period) => period.elements.find((element) => element.id === guid)).find(Boolean);
    return {
      total: module?.items?.length,
      completed: module?.items?.filter((item) => item.status !== 'pending').length,
    };
  };

  return {
    t,
    options,
    optionsModules,
    anchorLessons,
    openDropDownLessons,
    progress,
    isCompleted: sessionProgress === 100,
    hasStarted: sessionProgress > 0,
    hasCurrentSession,
    allSessionsCompleted,
    sessionDateDatesInfo,
    sessionProgress,
    handleCloseDropdown,
    onClickInOption,
  };
}

export default useModuleItem;
